<template>
  <div class="enroll" v-if="course.id">
    <div class="ch-header-paper">
      <div class="top"><h3>报名</h3></div>
      <div class="bottom"></div>
    </div>
    <div class="p10">
      <md-field
                :title="`${course.type_text}: ${course.age_start}岁 - ${course.age_end}岁`"
                :brief="description">
        <md-field-item solid title="单价">
          <span slot="right" class="price">
            ￥{{course.price}}/人
            <!--<template v-if="discountMoney != false"><br><em>已优惠：{{discountMoney}}</em></template>-->
          </span>
        </md-field-item>
        <md-field-item
                title="日期"
                arrow="arrow-right"
                :addon="selectedDate"
                @click="dateSelectorShow = true">
        </md-field-item>
        <md-field-item title="儿童" v-if="!isTrial">
          <md-stepper slot="right" v-model="qty" min="1" max="5" />
        </md-field-item>
        <md-field-item v-else solid title="儿童" :addon="`${qty}名`" />
        <md-field-item solid title="合计" :addon="'￥' + (displayPrice * qty).toFixed(2)" />
      </md-field>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
      <md-field title="监护人" class="mt10">
        <ValidationProvider name="监护人姓名" rules="required" v-slot="{ errors }">
        <md-input-item
                title="姓名"
                placeholder="监护人姓名"
                v-model="post.caregiver_name"
                :error="errors[0]"
        ></md-input-item>
        </ValidationProvider>
        <ValidationProvider name="联系电话" rules="required|mobile" v-slot="{ errors }">
        <md-input-item
                title="电话"
                type="tel"
                placeholder="联系电话"
                v-model="post.caregiver_tel"
                :error="errors[0]"
        ></md-input-item>
        </ValidationProvider>
      </md-field>

      <md-field class="mt10"
                v-for="(child, index) in postChildren"
                :key="index"
                :title="'儿童 ' + (index+1)"
      >
        <div class="action-container" slot="action" v-if="index > 0 && !isTrial">
          <md-icon name="close" @click="removeChild(index)"></md-icon>
        </div>
        <ValidationProvider name="姓名" rules="required" v-slot="{ errors }">
        <md-input-item
                title="姓名"
                placeholder="儿童姓名"
                v-model="child[0]"
                :key="index+'-name'"
                :name="'post.children[' + (index-1) + ']name'"
        ></md-input-item>
        </ValidationProvider>
        <ValidationProvider name="出生日期" rules="required" v-slot="{ errors }">
        <md-input-item
                title="生日"
                type="text"
                placeholder="出生日期"
                v-model="child[1]"
                :error="errors[0]"
                readonly
                @click.native="showPicker(index)"
        ></md-input-item>
        </ValidationProvider>
        <ValidationProvider name="性别" rules="required" v-slot="{ errors }">
          <md-field-item
                  title="性别"
                  solid
          >
            <md-radio name="boy" v-model="child[2]" label="男孩" inline />
            <md-radio name="girl" v-model="child[2]" label="女孩" inline />

          </md-field-item>

        </ValidationProvider>
      </md-field>


      <div class="mt10 fz14">
        <md-agree
                v-model="agreeChecked"
        >
          本人理解并同意<a href="javascript:;" class="term-btn" @click="showFullScreen=true">《活动参与条款》</a>
        </md-agree>
      </div>



      <div class="btn-wrap">
        <md-button type="primary" native-type="submit">确认报名</md-button>
      </div>

      </form>
      </ValidationObserver>
    </div>


    <payment
            :model="paymentInfo"
            v-if="showPayment"
            @onPaymentCancel="onPaymentCancel()"
            @onPaymentSuccess="onPaymentSuccess()"
    ></payment>


    <md-landscape v-model="showFullScreen" v-if="showFullScreen" full-screen>
      <page-content page_key="term" container="landscape"></page-content>
    </md-landscape>

    <md-date-picker
            ref="datePicker"
            title="选择出生日期"
            :max-date="new Date()"
            v-model="isDatePickerShow"
            @confirm="onDatePickerConfirm"
    ></md-date-picker>

    <!--<md-picker-->
            <!--ref="picker0"-->
            <!--v-model="isPickerShow"-->
            <!--:data="days"-->
            <!--large-radius-->
            <!--@confirm="onPickerConfirm()"-->
            <!--title="选择日期"-->
    <!--&gt;</md-picker>-->
    <enroll-date-selector
            v-if="course.id > 0"
            :course="course"
            :date-selector-show="dateSelectorShow"
            @close="dateSelectorShow = false"
            @dateChange="onDateConfirm"/>
  </div>
</template>

<script>
import { Field, FieldItem,InputItem,Button,Agree,Icon,Radio,Landscape,Stepper,DatePicker,Picker } from 'mand-mobile'
import { ValidationProvider,ValidationObserver,extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Payment from '../components/Payment.vue';
import PageContent from "../components/PageContent.vue";
import EnrollDateSelector from "../components/EnrollDateSelector.vue";
import enrollStorage from '../untils/enroll-storage'



extend('required', required);
extend('mobile', value => {
    if (/^(1\d{10}|1[\d-]{12})$/.test(value)) {
        return true;
    }

    return '请输入有效的手机号';
});

export default {
  name: "enroll",
  components: {
//    [Picker.name]: Picker,
    [Field.name]: Field,
    [FieldItem.name]: FieldItem,
    [InputItem.name]: InputItem,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Agree.name]: Agree,
    [Radio.name]: Radio,
      [Landscape.name]: Landscape,
      [Stepper.name]: Stepper,
      [DatePicker.name]: DatePicker,
      [Picker.name]: Picker,


      ValidationProvider,ValidationObserver,Payment,PageContent,
      EnrollDateSelector,
  },
  data() {
      return {
          type:"",
//          trial:'false',
          currentPickerIndex: -1,
          isDatePickerShow: false,
          showFullScreen: false,
          qtyPickerShow: false,
          qty:1,
          agreeChecked:true,
          qtyData:[],
          course:{id:null},
          coursePackage: {name:""},
          postChildren:[['','','boy']],
          post:{
              caregiver_name:"",
              caregiver_tel:"",
              session_no: 0,
          },
          showPayment: false,
          paymentInfo:{id:null},
          dateSelectorShow: false,
          days: [[{value:0, text:'2020-01-01 (0/9)', date:'2020-01-01'}]],
          selectedDate: "请选择",
//          showPayment: true,
//          paymentInfo:{id:1,payment_total:100.00},
      }
  },
  created() {
      this.initQtyData();
      this.initHistoryInput();
      const {courseId, type, packageId} = this.$route.query;
      this.type = type;
      if(courseId)
          this.loadData(courseId);
  },
  methods: {
      onPickerConfirm() {
          const values = this.$refs['picker-qty'].getColumnValues();
          const qty = values[0].value;
          const {postChildren} = this;
          if(postChildren.length >= qty) {
              this.postChildren = postChildren.splice(0, qty);
          } else {
              for(let i = this.qty;i<=qty;i++)
                postChildren.push(['','','boy']);

              this.postChildren = postChildren;
          }

          this.qty = qty;
      },
      initQtyData() {
          const qtyData = [];
          for(let i = 1;i<=5;i++) {
              qtyData.push({value:i,label:i+'人'})
          }
          this.qtyData = [qtyData];
      },
      loadData(id) {
          this.$toast.loading("加载中...");
          this.$http.get(`courses/${id}?enroll_history=1`)
              .then(({data}) => {
                  this.$toast.hide();
                  this.course = data;
                  //          days: [[{value:0, text:'2020-01-01 (0/9)', date:'2020-01-01'}]],
                  const days = [];
                  data.left_days.forEach((day) => {
                      days.push({value:day.no, text: `${day.date} (${day.enroll}/${data.capacity})`, date:day.date})
                  });
                  this.days = [days];
              })
              .catch(err => {
                  console.log(err);
                  //setTimeout(() => this.$toast.failed("课程不存在"), 300);
              });
      },
      removeChild(index) {
          if(index <= 0)
              return;
          const {postChildren} = this;
          this.postChildren = postChildren.filter((v, k) => {
              return k != index;
          });
          this.qty = this.postChildren.length;
      },
      onSubmit(e) {
        if(!this.agreeChecked) {
            this.$toast.failed("必须同意活动参与条款");
            return false;
        }

        const {id} = this.course;
        const children = [];
        this.postChildren.map((v) => {
           children.push({
               name:v[0],
               birthday:v[1],
               gender:v[2],
           })
        });
        const postData = {
            qty:this.qty,
            children:children,
            type:this.type,
            course_id: this.$route.query.courseId,
            ...this.post,
        };

        this.$toast.loading("提交中...");
        this.$http.post(`courses/${id}/enroll`, postData)
            .then(({data}) => {
                this.saveHistoryInput();
              console.log(data);
                this.$toast.hide();
                this.paymentInfo = data;
                this.showPayment = true;
            })
            .catch(({response}) => {
//                this.$toast.hide();
//                this.$toast.failed("加入失败");
              console.log(response);
            })
      },
      onPaymentCancel() {
          this.showPayment = false;
      },
      onPaymentSuccess() {
          this.showPayment = false;
          this.$toast.succeed('报名成功');
          setTimeout(() => {
              this.$toast.hide();
              this.$router.back();
          }, 1500);

      },
      initHistoryInput() {
          const saved = enrollStorage.get();
          this.post = {
              caregiver_name: saved.caregiver_name,
              caregiver_tel: saved.caregiver_tel,
          };
          this.postChildren[0] = saved.child;
      },
      saveHistoryInput() {
          enrollStorage.set({
              caregiver_name: this.post.caregiver_name,
              caregiver_tel: this.post.caregiver_tel,
              child: this.postChildren[0],
          })
      },
      onDatePickerConfirm(datePickerValue) {
//          console.log(e);
//          this.datePickerValue = this.$refs.datePicker.getFormatDate('yyyy/MM/dd hh:mm')
//          console.log(this.$refs.datePicker.getFormatDate('yyyy-MM-dd'));
          const {postChildren} = this;
          postChildren[this.currentPickerIndex][1] = this.$refs.datePicker.getFormatDate('yyyy-MM-dd');
          this.postChildren = postChildren;
      },
      showPicker(index) {
          this.isDatePickerShow = true;
          this.currentPickerIndex = index;
      },
      onDateConfirm(day) {
          this.selectedDate = day.date;
          this.post.session_no = day.no;
          this.dateSelectorShow = false;
      },
  },
    computed: {
        displayPrice() {
            return this.course.price;
//            const {type} = this.$route.query;
//            if(type == 'trial') {
//                return this.course.trial_price;
//            } else if(type == 'single') {
//                return this.course.single_price;
//            }
//
//            return this.$tools.displayPrice(this.course);
        },
        courseType() {
            const {type} = this.$route.query;
            if(type == 'trial') {
                return "[体验课]";
            } else if(type == 'single') {
                return "[单次课]";
            }

            return "";
        },
        isTrial() {
           return this.course.can_trial_enroll && this.$route.query.type == 'trial';
        },
        isSingle() {
            return this.course.single_price && this.$route.query.type == 'single';
        },
        discountMoney() {
            if(this.$route.query.type != 'normal' || !this.course.single_price)
                return false;

            const {course} = this;
            //const price = course.price/course.sessions;
            let saved = (course.single_price - (course.price/course.sessions)) * course.left;
            if(saved <= 0)
                return false;
            return saved.toFixed(2);
        },
        description() {
            const {course} = this;
            let str = `在${course.place}，由${course.leader.name}带领，编号：${course.no}`;
            if(!this.isTrial && course.left_start_day && course.left_start_day != course.end_day) {
                str += `。${course.left_start_day} 至 ${course.end_day} `;
            }

            return str;
        },
        priceText() {
          return this.$route.query.type == 'normal' ? '系列课' : '单价';
        }
    },
    watch: {
      qty(val) {
          console.log('qty change', val);
          const qty = val;
          const {postChildren} = this;
          if(postChildren.length >= qty) {
              this.postChildren = postChildren.splice(0, qty);
          } else {
              for(let i = this.qty;i<=qty;i++)
                  postChildren.push(['','','boy']);

              this.postChildren = postChildren;
          }
      }
    }
};
</script>
<style lang="scss" scoped>
  .btn-wrap {padding-top: 30px;}
  .term-btn{color:#5878B4;;text-decoration: none}
  .price {
    text-align: right;
    em {
      font-style: normal;
      font-size:24px;
      color: #f26522;
    }
  }
</style>